import * as React from "react";
import * as S from "@styled";
import { Utilities } from "../utilities";

type UploaderProps = UploaderOwnProps;

interface UploaderOwnProps {
    accepts: string;
    uploadUrl: string;
    buttonText: string;
    disabled?: boolean;
    resultHandler: (response: Response, file: File) => Promise<void>;
}

export class Uploader extends React.PureComponent<UploaderProps, {}> {
    private fileInput: HTMLInputElement;

    public render() {
        return (
            <div className="importButton" onClick={this.handleImportClicked} style={{ display: 'flex' }}>
                <div style={{ height: "0px", width: "0px", overflow: "hidden" }}>
                    <input ref={this.storeFileInputRef} onChange={this.handleFileInputChanged} disabled={this.props.disabled} id="importFileInput" type="file" accept={this.props.accepts} />
                </div>
                <S.ButtonIcon className="ci-folder_open" style={{ marginTop: '3px' }} />
                <span className="buttonTitle">&nbsp;{this.props.buttonText}</span>
            </div>
        );
    }

    private storeFileInputRef = (fileInput: HTMLInputElement) => this.fileInput = fileInput;

    private handleImportClicked = () => this.fileInput.click();

    private handleFileInputChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.uploadFile(event.target, this.props.uploadUrl);
    }

    private uploadFile = async (file: any, uploadUrl: string) => {
        if (file.files == null || file.files.length === 0) {
            return; // the file was cleared or not set
        }

        const formData = new FormData();
        const fileToUpload = file.files[0];
        formData.append("file", fileToUpload);

        await Utilities.postForm(uploadUrl, formData)
            .then(async (response) => await this.props.resultHandler(response, fileToUpload));
    }
}
